import React from 'react';
import cx from 'classnames';
const styles = require('./index.less');

/**
 * PageNum
 * @param currentPage {number} 当前页
 * @param total {number} 总页数
 * @param name {string}
 * @param onPrev {function}
 * @param onNext {function}
 * @param className {string}
 * @returns {JSX.Element}
 * @constructor
 */
const patchZero = num => {
  return num < 10 ? String(num).padStart(2, '0') : num;
};
const PageNum = ({ current, total, name = 'PAGE', onPrev, onNext, className, loop = true }) => {
  const onPrevClick = () => {
    if (current <= 1) {
      if (loop) {
        onPrev?.();
      }
    } else {
      onPrev?.();
    }
  };

  const onNextClick = () => {
    if (current >= total) {
      if (loop) {
        onNext?.();
      }
    } else {
      onNext?.();
    }
  };

  return (
    <div className={cx(styles.root, className, { [styles.loop]: loop })}>
      <div className={cx(styles.btnPrev, current <= 1 && styles.disabled)} onClick={onPrevClick}>
        <span className={styles.layer} />
      </div>
      <div className={styles.pageNum} data-name={name}>
        <mark>{patchZero(current)}</mark>
        <span className={styles.sperator}>/</span>
        {patchZero(total)}
      </div>
      <div className={cx(styles.btnNext, current >= total && styles.disabled)} onClick={onNextClick}>
        <span className={styles.layer} />
      </div>
    </div>
  );
};

export default PageNum;
